import multiApiClient from "./base";

export const MetabaseApi = {
  getEmbedToken: () => multiApiClient.get("/metabase/embed-token"),
};
